import { IPageLayout } from '@/types/types';
import { config } from '@/config';
import { ThemeVariables } from '@/themes/mpanels/variables';

const CURRENT_THEME = config.theme;

// eslint-disable-next-line @typescript-eslint/no-var-requires
const { variables } = require(`themes/${CURRENT_THEME}/variables`) as { variables: ThemeVariables };

export const getThemeProps = () => {
    const {
        themeName,
        layout: {
            helpCentreInsteadFaq,
            header: headerLayout = {},
            home: homeLayout,
            footer: footerLayout,
        },
    } = variables as { themeName: string; layout: IPageLayout };

    return { themeName, helpCentreInsteadFaq, headerLayout, homeLayout, footerLayout, variables };
};
